interface LabelledReference {
  readonly typeId: string;
  readonly value: string;
}

// The references of actors as one line: « Référence Sinistre : S-42, Référence : R-7 ».
export const externalReferencesLabelOf = (
  references: readonly LabelledReference[],
  typeLabelOf: (typeId: string) => string,
): string =>
  references
    .map(({ typeId, value }) => `${typeLabelOf(typeId)} : ${value}`)
    .join(', ');
